import { Box, BoxProps, Text, TextProps } from '@jfs/ui-new'

interface SubTitleProps {
  subTitle?: string
  textAlign?: 'auto' | 'left' | 'right' | 'center' | 'justify'
}

export const SubTitle = ({ subTitle = '', textAlign = 'center' }: SubTitleProps) => {
  return (
    <Box {...styles.container}>
      <Text {...styles.subTitle} textAlign={textAlign}>
        {subTitle}
      </Text>
    </Box>
  )
}

const styles = {
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  subTitle: {
    fontFamily: 'jioType-medium',
    fontSize: 12,
    lineHeight: 18,
    color: 'PRIMARY_GREY',
  } as TextProps,
}
